import React, {ReactNode, useMemo} from "react";
import {KeyProperties} from "../../../util/types";
import {AutocompleteProps} from "./types";
import {Autocomplete} from "./Autocomplete";
import {AutocompletePlaceholder} from "./AutocompletePlaceholder";

interface ObjectAutocompleteProps<T> {
  label: string
  options: T[]
  value: T|null
  onChange: (newValue: T) => void
  displayItem: (obj: T) => string
  idProperty: KeyProperties<T>
}
export const ObjectAutocomplete = function<T>(props: ObjectAutocompleteProps<T>): ReactNode {
  const getDisplayValue = (option: T) => {
    return props.displayItem(option)
  }
  const getKey = (option: T) => {
    return option[props.idProperty]
  }

  const options = useMemo(() => {
    return props.options.reduce<AutocompleteProps["options"]>((map, option) => {
      const key = getKey(option)
      // @ts-ignore
      map[key] = getDisplayValue(option)
      return map
    }, {})
  }, [props.options])

  const onChange = (newKey: string) => {
    const value = props.options.find(option => getKey(option) === newKey)
    if (value) {
      props.onChange(value)
    }
  }
  if (! props.value) {
    return <AutocompletePlaceholder label={props.label} />
  }
  return <Autocomplete label={props.label} options={options} value={getKey(props.value) as string} onChange={onChange} />
}
